<template>
    <x-quick-action-button title="Lihat Detail"
        :url="url"
        icon="eye"
        :disabled="disabled" />
</template>

<script>
import XQuickActionButton from './XQuickActionButton.vue'
export default {
    components: { XQuickActionButton },
    props: {
        disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
        url: {
            type: String,
            required: true,
        },
    },
}
</script>